<div class="anuncio-interesse-page" >
    <app-filter-anuncio [filtros]="filtro" [carregandoFiltros]="carregandoFiltros" (aplicarFiltroEmmit)="aplicarFiltroEmmit($event)" (exportarComFiltroEmmit)="exportarInteresses($event)"></app-filter-anuncio>
    <router-outlet></router-outlet>
</div>
